import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import BrandStory from "@/components/landing/BrandStory";
import Features from "@/components/landing/Features";
import ProductsGrid from "@/components/landing/ProductsGrid";
import CategoryBanners from "@/components/landing/CategoryBanners";
import Testimonials from "@/components/landing/Testimonials";
import EmailCTA from "@/components/landing/EmailCTA";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Navbar cartCount={2} />
      <Hero />
      <BrandStory />
      <Features />
      <ProductsGrid />
      <CategoryBanners />
      <Testimonials />
      <EmailCTA />
      <Footer />
    </main>
  );
}
